import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function PalmFilledIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.5879 4.79186C9.12261 4.63761 7.55271 4.80539 6.17486 5.46835C4.60348 6.22444 3.33024 7.60419 2.77415 9.74474C2.72028 9.9521 2.75765 10.1726 2.87685 10.3506C2.99604 10.5286 3.18567 10.6472 3.39791 10.6763C4.68675 10.8535 5.86751 10.7334 6.92987 10.3687C6.92585 11.0803 6.99394 11.6231 7.11947 12.0823C7.26514 12.6153 7.49573 13.031 7.68852 13.3786C7.74078 13.4728 7.79026 13.5621 7.83452 13.6472C8.02136 14.0068 8.46006 14.153 8.82523 13.9773C9.57149 13.6182 10.7595 12.5717 11.4454 10.7849C11.801 13.4859 11.5487 15.9684 10.2406 18.1644C7.71615 18.3928 5.19272 19.1127 2.67487 20.3242C2.30161 20.5038 2.14462 20.952 2.32421 21.3252C2.50381 21.6985 2.95198 21.8555 3.32524 21.6759C5.79494 20.4875 8.25851 19.8057 10.7212 19.6303C10.727 19.63 10.7328 19.6296 10.7386 19.6291C12.1164 19.5323 13.494 19.5941 14.8721 19.8144C14.8787 19.8156 14.8853 19.8166 14.8919 19.8176C16.8174 20.1275 18.7443 20.7469 20.6749 21.6759C21.0481 21.8555 21.4963 21.6985 21.6759 21.3252C21.8555 20.952 21.6985 20.5038 21.3252 20.3242C19.5148 19.4531 17.7015 18.8361 15.887 18.4733C16.3522 15.8104 16.112 12.8613 14.9683 10.0993C16.1231 10.5133 17.4399 10.6833 19 10.6833C19.2322 10.6833 19.4513 10.5758 19.5933 10.3922C19.7354 10.2085 19.7843 9.96945 19.726 9.74474C19.4664 8.74553 18.7012 7.62733 17.559 6.70984C18.9801 6.23926 20.2131 5.35453 20.7087 3.92372C20.8264 3.58398 20.6864 3.20852 20.3751 3.02874C18.9024 2.17842 16.6912 2.0832 14.7911 2.46152C13.8232 2.65424 12.8812 2.97949 12.0984 3.43654C11.5002 3.78587 10.9583 4.23427 10.5879 4.79186Z"
				fill="currentColor"
			/>
		</svg>
	);
}

PalmFilledIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default PalmFilledIcon;
